/**
 * Polling helpers gated by document visibility (Page Visibility API).
 */
function timers(vm) {
    if (!vm._foxTimers) {
        vm._foxTimers = {};
    }
    return vm._foxTimers;
}

function isVisible() {
    return document.visibilityState !== 'hidden';
}

function clearTimer(vm, key) {
    const id = timers(vm)[key];
    if (id != null) {
        clearTimeout(id);
        delete timers(vm)[key];
    }
}

function clearAllTimers(vm) {
    const map = timers(vm);
    Object.keys(map).forEach((key) => {
        clearTimeout(map[key]);
        delete map[key];
    });
}

function schedule(vm, key, fn, delayMs) {
    clearTimer(vm, key);
    if (!isVisible()) {
        return null;
    }
    timers(vm)[key] = setTimeout(fn, delayMs);
    return timers(vm)[key];
}

function install(vm, handlers) {
    if (vm._foxVisibilityInstalled) {
        return;
    }
    vm._foxVisibilityInstalled = true;

    const onChange = () => {
        if (isVisible()) {
            if (handlers && typeof handlers.onVisible === 'function') {
                handlers.onVisible();
            }
        } else if (handlers && typeof handlers.onHidden === 'function') {
            handlers.onHidden();
        }
    };

    vm._foxVisibilityHandler = onChange;
    document.addEventListener('visibilitychange', onChange);
}

function uninstall(vm) {
    if (vm._foxVisibilityHandler) {
        document.removeEventListener('visibilitychange', vm._foxVisibilityHandler);
        vm._foxVisibilityHandler = null;
    }
    clearAllTimers(vm);
    vm._foxVisibilityInstalled = false;
}

module.exports = {
    isVisible,
    install,
    uninstall,
    clearTimer,
    clearAllTimers,
    schedule,
};
